import { useContext, useEffect, useState } from 'react';
import { SelectedAcodesContext } from '../context/SelectedAcodes';
import { TrackingEvents } from '../types/enums/tracking-events.enum';
import { VehicleListType } from '../types/tracking';
import { useFeatureServices } from '../use-feature-services';

const useTrackResults = () => {
  const [initialLoad, setInitialLoad] = useState<boolean>(true);
  const { tracking } = useFeatureServices();
  const { vehicles } = useContext(SelectedAcodesContext);

  useEffect(() => {
    if (!vehicles.length && !initialLoad) return;

    if (initialLoad) {
      const vehicleListData: VehicleListType[] = vehicles.map((vehicle) => ({
        CarlineId: vehicle?.carline_id,
        CarlineName: vehicle.trim,
        Manufacturer: vehicle.make,
        ModelId: vehicle?.sales_code,
        ModelName: vehicle.model,
        ModelYear: vehicle.year
      }));

      const vehicleNames : string[] = vehicles.map(d => d.model);
      const primaryVehicle = vehicles[0];

      tracking.track(TrackingEvents.FEATUREAPP_LOAD, {
        eventInfo: {
          eventAction: TrackingEvents.FEATUREAPP_LOAD,
          contentId: "compare dimensions"
        },
        environment: {
          featureAppId: 'CompareDimensionsWidget-D6-CA',
          featureAppIdAppVersion: '1.0',
        },
        personalization: {
          status: false,
        },
        configuration: {
          CarlineId: primaryVehicle?.carline_id,
          CarlineName: primaryVehicle?.model,
          ModelId: primaryVehicle?.sales_code,
          ModelName: primaryVehicle?.model,
          ModelYear: primaryVehicle?.year.toString(),
          vehicleList: vehicleListData
        },
        filter: {
          type: 'multi_value',
          name: 'selected models',
          numberOfResults: vehicles.length,
          results: vehicleNames
        }
      });

      setInitialLoad(false);
    }
  }, [vehicles, initialLoad]);

  return initialLoad;
};

export default useTrackResults;
